import request from '@/utils/request'
// const server = "/cloudhealth-server-portal"
import Vue from 'vue'
// const server = Vue.prototype.portal
const server = "/business";

// 患者检验列表
export function getLabInfos(query) {
  return request({
    url: server+'/healthinfo/getTestReports',
    method: 'post',
    data: query
  })
}

export function turnToPageLabInfos(query) {
  return request({
    url: server+'/healthinfo/getTestReports?page=' + query.pageNum + '&pageSize=' + query.pageSize,
    method: 'post',
    data: query
  })
}

//获取患者检验详细信息
export function getLabInfoDetail(id) {
  return request({
    url: server+'/healthinfo/getTestReportDetail',
    method: 'get',
    params: {id:id}
  })
}

// 患者检验项目列表
export function getLabItems(query) {
  return request({
    url: server+'/healthinfo/getTestReportItems',
    method: 'post',
    params: query
  })
}

// 添加患者检验
export function addPersonalTestItems(query) {
  return request({
    url: server+'/healthinfo/addPersonalTestItems',
    method: 'post',
    params: query
  })
}

// 编辑患者检验
export function updatePersonalTestItems(query) {
  return request({
    url: server+'/healthinfo/updatePersonalTestItem',
    method: 'post',
    params: query
  })
}

// 删除患者检验
export function deletePersonalTestItems(query) {
  return request({
    url: server+'/healthinfo/removePersonalTestItems',
    method: 'post',
    params: query
  })
}

// 编辑患者检验名称
export function updatePersonalTestItemName(query) {
  return request({
    url: server+'/healthinfo/updatePersonalTestItemName',
    method: 'post',
    params: query
  })
}
